/* eslint-disable max-len */
// THIS FILE IS USED TO GENERATE CHUNKS PER PAGE
// SO THAT SPA'S CAN LOAD THE NECESSARY CHUNKS PER PAGE
/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined';

export const getServerPages = async () => {
  const Components = {};
  if (ssr) {
    Components.home = (await import('./pages/Home')).Home;
    Components.debug = (await import('./pages/debug/SetCookies')).SetCookies;
  }
  return Components;
};

export const getRoutes = (currentRouteName, currentRouteComponent, serverPages) => ({
  home: {
    name: 'Home',
    componentName: 'Home',
    chunk: () => import('./pages/Home'),
    get component() {
      return ssr
        ? serverPages.home
        : currentRouteName === 'Home'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.Home })));
    },
    path: '/:context?/auth',
    channel: null
  },
  debug: {
    name: 'SetCookies',
    componentName: 'SetCookies',
    chunk: () => import('./pages/debug/SetCookies'),
    get component() {
      return ssr
        ? serverPages.debug
        : currentRouteName === 'SetCookies'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.SetCookies })));
    },
    path: '/debug/exchange/setcookies',
    channel: null
  },
});
